import { ApolloClient } from "apollo-boost";
import { AppStateContext } from "AppState";
import RightLeftLayout from "components/common/RightLeftLayout/RightLeftLayout";
import { ConfigurationLoaderContext } from "components/Gates/ConfigurationLoaderGate";
import { LocationState } from "history";
import * as React from "react";
import { ApolloConsumer } from "react-apollo";
import { getCurrentLocation } from "utils/apis";
import OrderSummary from "./OrderSummary";
import PointsSummary from "./PointsSummary";

export interface IProps {
  rewardImageBaseUrl?: string;
  location: LocationState;
  locationName: string;
}

export interface IState {
  tenantId: string;
  locationId: string;
}

class RedeemComplete extends React.Component<
  IProps & { client: ApolloClient<any> },
  IState
> {
  constructor(props: IProps & { client: ApolloClient<any> }) {
    super(props);
    this.state = {
      tenantId: "",
      locationId: ""
    };
  }

  public async componentDidMount() {
    await this.getCurrentUser();
  }

  public render() {
    const { rewards, pointsBalance, total } = this.props.location.state;
    return (
      <div>
        <RightLeftLayout
          title={this.props.locationName}
          titleSecondary="Rewards Summary"
          closeButtonHandler
          leftPanel={
            <OrderSummary
              rewards={rewards}
              total={total}
              tenantId={this.state.tenantId}
              locationId={this.state.locationId}
              rewardImageBaseUrl={this.props.rewardImageBaseUrl}
            />
          }
          rightPanel={
            <PointsSummary pointsBalance={pointsBalance} total={total} />
          }
        />
      </div>
    );
  }

  private getCurrentUser = async () => {
    try {
      const location = await getCurrentLocation(this.props.client);
      this.setState({
        tenantId: location.tenantId,
        locationId: location.locationId
      });
    } catch (e) {
      console.error(e);
    }
  };
}

export default (props: IProps) => (
  <ApolloConsumer>
    {client => (
      <ConfigurationLoaderContext.Consumer>
        {config =>
          config && (
            <AppStateContext.Consumer>
              {([appState]) => (
                <RedeemComplete
                  client={client}
                  rewardImageBaseUrl={config.reward_images_base_url}
                  locationName={appState.locationName}
                  {...props}
                />
              )}
            </AppStateContext.Consumer>
          )
        }
      </ConfigurationLoaderContext.Consumer>
    )}
  </ApolloConsumer>
);



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/RedeemCompelte/RedeemComplete.tsx